<template>
  <div class="spl-deadline-list-header">
    <form-button @onClick="handleCreateDeadline">
      Create Deadline
    </form-button>
    <form-button
      style="grid-column: 3"
      data-cy="deadline-detail-header-excel"
      @onClick="handleDownload">
      Excel
    </form-button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { round } from 'lodash'
import Helpers from '@/helpers.vue'

export default {
  mixins: [Helpers],
  computed: {
    ...mapGetters('deadline', ['deadlineList'])
  },
  methods: {
    handleCreateDeadline () {
      this.$router.push('/deadline-create')
    },
    handleDownload () {
      var excelList = {
        Columns: [],
        Rows: [],
        Filter: {
        }
      }
      var selectedFields = [
        { name: 'Customer_Name', label: 'Customer', type: 'String' },
        { name: 'Country_Name', label: 'Country', type: 'String' },
        { name: 'Service_Level_Name', label: 'Service Level', type: 'String' },
        { name: 'From_Postal_Code', label: 'From Postal Code', type: 'String' },
        { name: 'To_Postal_Code', label: 'To Postal Code', type: 'String' },
        { name: 'City', label: 'City', type: 'String' },
        { name: 'Open_Deadline_Day', label: 'Open Deadline Day', type: 'String' },
        { name: 'Open_Deadline_Time', label: 'Open Deadline Time', type: 'String' },
        { name: 'Close_Deadline_Day', label: 'Close Deadline Day', type: 'String' },
        { name: 'Close_Deadline_Time', label: 'Close Deadline Time', type: 'String' },
        { name: 'Valid_From', label: 'Valid From', type: 'Date' },
        { name: 'Valid_To', label: 'Valid To', type: 'Date' },
        { name: 'Weekend_Delivery', label: 'Weekend Delivery', type: 'Boolean' },
        { name: 'Created_On', label: 'Created On', type: 'Date' },
        { name: 'User_Name', label: 'User', type: 'String' }
      ]
      // Loop through the columns and add them to excel object
      for (let i = 0; i < selectedFields.length; i++) {
        const field = selectedFields[i]
        excelList.Columns.push({ ID: field.name, Header: field.label, Type: this.getColumnType(field.type) })
      }

      const results = this.deadlineList
      // add the values
      for (let i = 0; i < results.length; i++) {
        var rowValues = { Value: [] }
        const result = results[i]
        for (let j = 0; j < selectedFields.length; j++) {
          const field = selectedFields[j]
          rowValues.Value.push(this.formatField(result[field.name], field.type, field.name))
        }
        excelList.Rows.push(rowValues)
      }
      // Call the excel download helper
      this.getexcelDownload(excelList, 'Deadlines.xlsx')
    },
    getColumnType (fieldType) {
      // Converts the formats into excel compatible ones
      // "Number", "DateTime", "Text", "Boolean"
      if (fieldType) {
        switch (fieldType) {
          case 'Number':
          case 'Number.2':
          case 'Number.3':
            return 'Number'

          case 'Boolean' :
            return 'Boolean'

          case 'Date':
          case 'Timestamp':
            return 'DateTime'

          case 'String':
          default:
            return 'Text'
        }
      }
      return ''
    },
    // Special formatting for fields
    formatField (field, type, name) {
      // empty fields will be removed
      if (field === null) {
        return ''
      }
      switch (type) {
        case 'Number.2':
          return round(field, 2).toFixed(2)
        case 'Number.3' :
          return round(field, 3).toFixed(3)
        case 'Date':
          return this.formatDate(field, false, 'YYYY-MM-DD')
        case 'Timestamp':
          return this.formatDate(field, true, 'YYYY-MM-DD HH:mm')
      }
      return field
    }
  }
}
</script>

<style lang="scss">
  @import '../../../variables.scss';

  .spl-deadline-list-header {
    position: relative;
    padding: 0 $mainPadding;
    margin: 15px 0;
  }

</style>
